import Vue from 'vue'
import App from './App.vue'
import $ from "jquery"
import 'animate.css/animate.min.css'
import 'slick-carousel/slick/slick.css';


Vue.config.productionTip = false;
Vue.config.filenameHashing = false;
Vue.prototype.$eventHub = new Vue();

new Vue({
  render: h => h(App),
  
}).$mount('#app')


// Scale javascript
$(document).ready(

  function()
  {
    console.log("aaa");
    calculateNewScale();
  }
);

$(window).resize(function () 
{
    calculateNewScale();
});

function calculateNewScale()
{
    var per1 = $(window).width() / 1920;
    var per2 = $(window).height() / 1080;
    if (per1>per2)
    {
      per1 = per2;
    }
    
    $("#app").css(
    {
        "transform": "translate(-50%, -50%) scale("+per1+")"
    });
    
}